import { Link } from 'react-router-dom';

const ProductTitle = ({ productName, loading, breadcrumb = {}, back = null }) => {
    if (loading) return;

    return (
        <div className="relative z-[1] mb-10 md:mb-16 xl:mb-20 before:content-[''] before:absolute before:top-0 before:bottom-0 before:w-screen before:left-1/2 before:bg-quaternary before:-translate-x-1/2 before:-z-[1]">
            <div className="flex flex-col py-5 md:py-10">
                {breadcrumb.length ? (
                    <div className="flex flex-wrap max-sm:gap-y-0 max-sm:gap-x-3 gap-4">
                        {breadcrumb.map((item, index) => (
                            <div key={index} className="flex items-center">
                                <Link to={item.link} className="transition-all hover:opacity-75">
                                    <h4 className="text-sm md:text-base lg:text-lg text-white font-medium uppercase tracking-wider">
                                        {item.label}
                                    </h4>
                                </Link>
                                {index < breadcrumb.length - 1 && (
                                    <span className="w-1.5 sm:w-2 h-1.5 sm:h-2 border-t border-r border-white rotate-45 mt-0.5 ml-1.5 md:ml-2"></span>
                                )}
                            </div>
                        ))}

                        {back && (
                            <Link
                                to={back}
                                className="ml-auto px-5 py-1.5 flex items-center text-white uppercase gap-3 tracking-wider border border-white rounded-full transition-all hover:bg-white hover:text-tertiary"
                            >
                                <svg
                                    width="24.2"
                                    height="16"
                                    viewBox="0 0 24.2 16"
                                    className="fill-secondary"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M23.2,7H3.4l4.7-4.7c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0L0.3,7.3C0.2,7.4,0.1,7.5,0.1,7.6
                                        C0,7.7,0,7.9,0,8c0,0,0,0,0,0s0,0,0,0c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.3l6.4,6.4c0.4,0.4,1,0.4,1.4,0
                                        c0.4-0.4,0.4-1,0-1.4L3.4,9h19.7c0.6,0,1-0.4,1-1S23.7,7,23.2,7z"
                                    />
                                </svg>

                                <span className="max-md:hidden">Voltar</span>
                            </Link>
                        )}
                    </div>
                ) : (
                    <div className="flex flex-wrap max-sm:gap-y-0 max-sm:gap-x-3 gap-4">
                        <h4 className="text-sm md:text-base lg:text-lg text-white font-medium uppercase tracking-wider -mb-2">Produto</h4>

                        {back && (
                            <Link
                                to={back}
                                className="ml-auto px-5 py-1.5 flex items-center text-white uppercase gap-3 tracking-wider border border-white rounded-full transition-all hover:bg-white hover:text-tertiary"
                            >
                                <svg
                                    width="24.2"
                                    height="16"
                                    viewBox="0 0 24.2 16"
                                    className="fill-secondary"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M23.2,7H3.4l4.7-4.7c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0L0.3,7.3C0.2,7.4,0.1,7.5,0.1,7.6
                                        C0,7.7,0,7.9,0,8c0,0,0,0,0,0s0,0,0,0c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.3l6.4,6.4c0.4,0.4,1,0.4,1.4,0
                                        c0.4-0.4,0.4-1,0-1.4L3.4,9h19.7c0.6,0,1-0.4,1-1S23.7,7,23.2,7z"
                                    />
                                </svg>

                                <span className="max-md:hidden">Voltar</span>
                            </Link>
                        )}
                    </div>
                )}
                <h2 className="max-sm:text-2xl max-lg:text-4xl max-md:mt-2 lg:text-[44px] text-secondary font-semibold">{productName}</h2>
            </div>
        </div>
    );
};

export default ProductTitle;
